export default __webpack_public_path__ + "static/N0153-90eec671ae85d2253edaeb292ccffcbf.png";